// extracted by mini-css-extract-plugin
export default {"container":"DownloadFilePage_container__644xy"};